import DomFactory from '../factory/factory';

export default class Builder<
  T extends { wrapper: HTMLElement },
  F extends DomFactory,
> {
  protected readonly factory: F;
  protected elements: T;
  protected eventCleanup: (() => void)[] = [];
  constructor(factory: F) {
    this.factory = factory;
    this.elements = {
      wrapper: this.factory.createWrapper(),
    } as T;
  }

  public build() {
    return this.elements.wrapper;
  }

  private cleanupEvents() {
    this.eventCleanup.forEach(cleanup => cleanup());
    this.eventCleanup = [];
  }

  private cleanupElements() {
    for (const element of Object.values(this.elements)) element?.remove();
    this.elements = {
      wrapper: this.factory.createWrapper(),
    } as T;
  }

  public cleanup() {
    this.cleanupEvents();
    this.cleanupElements();
  }
}
